import { PolicyView } from '../../../../../../services/CaseManagementService';
import { CategoryTemplate } from './CategoryTemplate';
import { DateTemplate } from './DateTemplate';
import { PolicyNameTemplate } from './PolicyNameTemplate';
import { PolicyNumberTemplate } from './PolicyNumberTemplate';

// Template functions for grid columns
export const categoryTemplate = (props: PolicyView) => (
  <CategoryTemplate category={props.category} />
);

export const policyNameTemplate = (props: PolicyView) => (
  <PolicyNameTemplate name={props.policyName} />
);

export const policyNumberTemplate = (props: PolicyView) => (
  <PolicyNumberTemplate number={props.policyNumber} />
);

/**
 * Create a date template for a specific field
 */
export const createDateTemplate =
  (field: keyof PolicyView) => (rowData: PolicyView) => (
    <DateTemplate dateValue={rowData[field] as string | null | undefined} />
  );
